import { render, staticRenderFns } from "./details-form.vue?vue&type=template&id=27cd7294"
import script from "./details-form.vue?vue&type=script&lang=js"
export * from "./details-form.vue?vue&type=script&lang=js"
import style0 from "./details-form.vue?vue&type=style&index=0&id=27cd7294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports